import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from '../routes';
import PageScrollTop from '../component/PageScrollTop';
import ReactGA from 'react-ga4';
ReactGA.initialize('G-M07LX4W1SN');
ReactGA.send(window.location.pathname + window.location.search);

function App() {
    return (
        <Router>
            <PageScrollTop>
                <Routes />
            </PageScrollTop>
        </Router>
    );
}
export default App;
